import React from "react";
import {Route, Routes} from "react-router-dom";
import ComingSoonPage from "views/pages/coming_soon/coming_soon.page";

export const SecretGateRoutes: React.FC = () => (
	<Routes>
		<Route path="*" element={<ComingSoonPage />} />
	</Routes>
);

export default SecretGateRoutes;
